const API_TOKEN = 'A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2';

const BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://api.ruqqiasultanaclinic.com' 
  : ''
const headers = {
  'accept': '*/*',
  'X-API-TOKEN': API_TOKEN,
};

// Get all patients list
export const fetchPatients = async () => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientdetails/get`, { headers });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
};

// Get single patient by ID (returns patientDetails + patientBill)
export const fetchPatientById = async (id) => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientdetails/get/${id}`, { headers });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
};

export const fetchAllBabies = async () => {
  const response = await fetch(`${BASE_URL}/api/Patient/babytdetails/get`, { headers });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
};

export const createPatientBill = async (billData) => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientbill/create`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(billData),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
};

// Get all bills from API
export const fetchAllBills = async () => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientbilldetails/get`, { headers });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
};

// Update existing bill
export const updatePatientBill = async (billData) => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientbill/update`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(billData),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
};

// Create new patient
export const createPatient = async (patientData) => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientdetails/create`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(patientData),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
};

// Create baby record
export const createBabyRecord = async (babyData) => {
  const response = await fetch(`${BASE_URL}/api/Patient/babyrecordinsert`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(babyData),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
};

// Create discharge request
export const createDischargeRequest = async (payload) => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientdischargerequest/create`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

// Fetch all discharge requests (pass 0 and true to get all)
export const fetchDischargeRequests = async () => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientdischarge/get/0/true`, { headers });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

// Update discharge request (allow or reject)
export const updateDischargeRequest = async (payload) => {
  const response = await fetch(`${BASE_URL}/api/Patient/patientdischargerequest/update`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};


export const createMedicalRecord = async (payload) => {
  const res = await fetch(`${BASE_URL}/api/Patient/CreateMedicalRecord`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const updateMedicalRecord = async (payload) => {
  const res = await fetch(`${BASE_URL}/api/Patient/UpdateMedicalRecord`, {
    method: 'PUT',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const getMedicalRecords = async (patientId = 0) => {
  const res = await fetch(`${BASE_URL}/api/Patient/GetMedicalRecord?PatientId=${patientId}`, {
    headers,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const getPatientDropdown = async () => {
  const res = await fetch(`${BASE_URL}/api/Patient/patientdropdown/get`, {
    headers,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};



// ── Staff Credentials ─────────────────────────────────────────

export const fetchAllStaff = async () => {
const response = await fetch(`${BASE_URL}/api/Patient/staff/get-all`, { headers });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const fetchStaffById = async (id) => {
  const response = await fetch(`${BASE_URL}/api/Patient/staff/get-by-id/${id}`, { headers });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const createStaff = async (payload) => {
  const response = await fetch(`${BASE_URL}/api/Patient/staff/create`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const updateStaff = async (payload) => {
  const response = await fetch(`${BASE_URL}/api/Patient/staff/update`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};


// Fetch all income/expense records
export const fetchAllIncomeExpense = async () => {
  const response = await fetch(`${BASE_URL}/api/Patient/IncomeExpense/All`, { headers });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

// Create income/expense record
export const createIncomeExpense = async (payload) => {
  const response = await fetch(`${BASE_URL}/api/Patient/IncomeExpense/Create`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const text = await response.text();
  try { return JSON.parse(text); } catch { return text; }
};

export const updateIncomeExpense = async (payload) => {
  const response = await fetch(`${BASE_URL}/api/Patient/IncomeExpense/Update`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const text = await response.text();
  try { return JSON.parse(text); } catch { return text; }
};